import { Container } from 'inversify'
import { SERVICES as SERVICES_UTILS } from '../Utils/Caching/serviceRegistration'
import { CacheService } from '../Utils/Caching/cacheService'
import { getAuctionPageProperties } from './getAuctionPageProperties'
import { AuctionPageProperties } from './AuctionPageProperties'
import { GetAuctionPagePropertiesRequest } from './GetAuctionPagePropertiesRequest'
import { ConfigProvider } from '../Base/ConfigProvider'
import { SERVICES as SERVICES_BASE } from '../Base/serviceRegistration'

export type GetAuctionPagePropertiesType = (request: GetAuctionPagePropertiesRequest) => Promise<AuctionPageProperties>

export const SERVICES = {
  getAuctionPageProperties: Symbol.for('getAuctionPageProperties'),
}

export function registerBinding(container: Container): void {
  container
    .bind<GetAuctionPagePropertiesType>(SERVICES.getAuctionPageProperties)
    .toConstantValue((request: GetAuctionPagePropertiesRequest) => {
      const cache = container.get<CacheService>(SERVICES_UTILS.CacheService)
      const configProvider = container.get<ConfigProvider>(SERVICES_BASE.ConfigProvider)
      return getAuctionPageProperties(configProvider, cache, request)
    })
}

//  DO NOT DELETE - used by DW
